import React from 'react';

import WrappedSignUpForm from 'components/HomePage/SignUpForm';
import authPageBg from 'assets/auth-page-bg.jpg';
import PageTitle from 'shared/PageTitle';

const SignUpPage = () => {
  return (
    <div>
      <PageTitle title="Apply Now" />
      <div
        className="sign-up-page bg-dark-grey auth-page"
        style={{ backgroundImage: `url(${authPageBg})` }}>
        <div className="row no-margin justify-content-center align-items-center">
          <div className="col-md-5 col-lg-4 col-sm-10">
            <WrappedSignUpForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage;



// WEBPACK FOOTER //
// ./src/components/HomePage/SignUpPage.js